module.exports = __webpack_public_path__ + "static/media/MuseoSansLight.e386bd26.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansLight/MuseoSansLight.woff
// module id = 640
// module chunks = 0